export default "__VITE_ASSET__85ef1407__"